// extracted by mini-css-extract-plugin
export default {"logoutComponent":"_2X-2kB","btnCarrot":"_3bNNN_"};